import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "full-width"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.provider,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.provider) = $event)),
          class: "full-width"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, {
              label: _ctx.ProviderType.ORGANISATION
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Organisation ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"]),
            _createVNode(_component_el_radio, {
              label: _ctx.ProviderType.BODY
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Body ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["label"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _withDirectives(_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "full-width",
              modelValue: _ctx.modelValue.providerOrganisationId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.providerOrganisationId) = $event)),
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              placeholder: "Please enter a name or an ID",
              "remote-method": _ctx.organisationsRemoteSearch
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organisations, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.label,
                    value: item.value,
                    key: item.value
                  }, null, 8 /* PROPS */, ["label", "value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "remote-method"])
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.modelValue.isOrganisationProvider()]
        ]),
        _withDirectives(_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              class: "full-width",
              modelValue: _ctx.modelValue.providerBodyId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelValue.providerBodyId) = $event)),
              filterable: "",
              remote: "",
              "reserve-keyword": "",
              placeholder: "Please enter a name or an ID",
              "remote-method": _ctx.bodiesRemoteSearch
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bodies, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.label,
                    value: item.value,
                    key: item.value
                  }, null, 8 /* PROPS */, ["label", "value"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "remote-method"])
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.modelValue.isBodyProvider()]
        ])
      ]))
    : _createCommentVNode("v-if", true)
}